var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "container" },
    [
      _c(
        "a-modal",
        {
          staticStyle: { top: "10%", height: "80%" },
          attrs: {
            title: _vm.title,
            width: 1200,
            visible: _vm.visible,
            confirmLoading: _vm.confirmLoading,
            getContainer: () => _vm.$refs.container,
            maskStyle: { top: "93px", left: "154px" },
            wrapClassName: _vm.wrapClassNameInfo(),
            mask: _vm.isDesktop(),
            maskClosable: false,
            cancelText: "取消",
            okText: "保存",
          },
          on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
        },
        [
          _c(
            "template",
            { slot: "footer" },
            [
              _vm.isReadOnly
                ? _c(
                    "a-button",
                    { key: "back", on: { click: _vm.handleCancel } },
                    [_vm._v("\n        取消\n      ")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "a-spin",
            { attrs: { spinning: _vm.confirmLoading } },
            [
              _c(
                "a-form",
                { attrs: { form: _vm.form, id: "customerModal" } },
                [
                  _c(
                    "a-row",
                    { staticClass: "form-row", attrs: { gutter: 24 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 24 / 2 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                label: "名称",
                              },
                            },
                            [
                              _c("a-input", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator.trim",
                                    value: [
                                      "supplier",
                                      _vm.validatorRules.supplier,
                                    ],
                                    expression:
                                      "[ 'supplier', validatorRules.supplier]",
                                    modifiers: { trim: true },
                                  },
                                ],
                                attrs: { placeholder: "请输入名称" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 24 / 2 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                label: "联系人",
                              },
                            },
                            [
                              _c("a-input", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator.trim",
                                    value: ["contacts"],
                                    expression: "[ 'contacts' ]",
                                    modifiers: { trim: true },
                                  },
                                ],
                                attrs: { placeholder: "请输入联系人" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-row",
                    { staticClass: "form-row", attrs: { gutter: 24 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 24 / 2 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                label: "手机号码",
                              },
                            },
                            [
                              _c("a-input", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator.trim",
                                    value: ["telephone"],
                                    expression: "[ 'telephone' ]",
                                    modifiers: { trim: true },
                                  },
                                ],
                                attrs: { placeholder: "请输入手机号码" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 24 / 2 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                label: "联系电话",
                              },
                            },
                            [
                              _c("a-input", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator.trim",
                                    value: ["phoneNum"],
                                    expression: "[ 'phoneNum' ]",
                                    modifiers: { trim: true },
                                  },
                                ],
                                attrs: { placeholder: "请输入联系电话" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 24 / 2 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                label: "电子邮箱",
                              },
                            },
                            [
                              _c("a-input", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator.trim",
                                    value: ["email"],
                                    expression: "[ 'email' ]",
                                    modifiers: { trim: true },
                                  },
                                ],
                                attrs: { placeholder: "请输入电子邮箱" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 24 / 2 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                label: "传真",
                              },
                            },
                            [
                              _c("a-input", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator.trim",
                                    value: ["fax"],
                                    expression: "[ 'fax' ]",
                                    modifiers: { trim: true },
                                  },
                                ],
                                attrs: { placeholder: "请输入传真" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 24 / 2 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                label: "期初应收",
                              },
                            },
                            [
                              _c("a-input", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator.trim",
                                    value: ["beginNeedGet"],
                                    expression: "[ 'beginNeedGet' ]",
                                    modifiers: { trim: true },
                                  },
                                ],
                                attrs: { placeholder: "请输入期初应收" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 24 / 2 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                label: "期末应收",
                              },
                            },
                            [
                              _c("a-input", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator.trim",
                                    value: ["allNeedGet"],
                                    expression: "[ 'allNeedGet' ]",
                                    modifiers: { trim: true },
                                  },
                                ],
                                attrs: { readOnly: true },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 24 / 2 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                label: "纳税人识别号",
                              },
                            },
                            [
                              _c("a-input", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator.trim",
                                    value: ["taxNum"],
                                    expression: "[ 'taxNum' ]",
                                    modifiers: { trim: true },
                                  },
                                ],
                                attrs: { placeholder: "请输入纳税人识别号" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 24 / 2 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                label: "税率(%)",
                              },
                            },
                            [
                              _c("a-input-number", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator.trim",
                                    value: ["taxRate"],
                                    expression: "[ 'taxRate' ]",
                                    modifiers: { trim: true },
                                  },
                                ],
                                staticStyle: { width: "100%" },
                                attrs: { placeholder: "请输入税率" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 24 / 2 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                label: "开户行",
                              },
                            },
                            [
                              _c("a-input", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator.trim",
                                    value: ["bankName"],
                                    expression: "[ 'bankName' ]",
                                    modifiers: { trim: true },
                                  },
                                ],
                                attrs: { placeholder: "请输入开户行" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 24 / 2 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                label: "账号",
                              },
                            },
                            [
                              _c("a-input", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator.trim",
                                    value: ["accountNumber"],
                                    expression: "[ 'accountNumber' ]",
                                    modifiers: { trim: true },
                                  },
                                ],
                                attrs: { placeholder: "请输入账号" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 24 / 2 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                label: "地址",
                              },
                            },
                            [
                              _c("a-input", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator.trim",
                                    value: ["address"],
                                    expression: "[ 'address' ]",
                                    modifiers: { trim: true },
                                  },
                                ],
                                attrs: { placeholder: "请输入地址" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 24 / 2 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                label: "排序",
                              },
                            },
                            [
                              _c("a-input", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator.trim",
                                    value: ["sort"],
                                    expression: "[ 'sort' ]",
                                    modifiers: { trim: true },
                                  },
                                ],
                                attrs: { placeholder: "请输入排序" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 24 / 2 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                label: "备注",
                              },
                            },
                            [
                              _c("a-textarea", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator.trim",
                                    value: ["description"],
                                    expression: "[ 'description' ]",
                                    modifiers: { trim: true },
                                  },
                                ],
                                attrs: { rows: 2, placeholder: "请输入备注" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }